import { render, staticRenderFns } from "./other-prem.vue?vue&type=template&id=295dfb5e&scoped=true"
import script from "./other-prem.vue?vue&type=script&setup=true&lang=ts"
export * from "./other-prem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./other-prem.vue?vue&type=style&index=0&id=295dfb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295dfb5e",
  null
  
)

export default component.exports